import { render } from "./ProjectBox.vue?vue&type=template&id=a61db320&scoped=true"
import script from "./ProjectBox.vue?vue&type=script&lang=js"
export * from "./ProjectBox.vue?vue&type=script&lang=js"

import "./ProjectBox.vue?vue&type=style&index=0&id=a61db320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61db320"]])

export default __exports__